import { useTenant } from '../tenant/TenantContext'

export default function TenantSelector() {
  const { tenants, current, setCurrentById } = useTenant()
  // Hide selector if only one tenant named 'default'
  if (!tenants?.length) return null
  const allDefault = tenants.every(t => ((t.name || '').toLowerCase().trim() === 'default'))
  if (tenants.length === 1 || allDefault) return null
  return (
    <select className="input" value={current?.id ?? ''} onChange={e => setCurrentById(Number(e.target.value))}>
      {tenants.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
    </select>
  )
}
